// =============================================================================
// actions/lookupActions.js
//
// Thunk action to load the lookups (vendors, techs, kpis, severities,
// statuses) that feed the filter dropdowns. Loaded once at dashboard start.
// =============================================================================
import {
	LOOKUPS_FETCH_REQUEST, LOOKUPS_FETCH_SUCCESS, LOOKUPS_FETCH_FAILURE,
} from '../constants/kpiConstants';
import { apiFetchLookups } from '../requests/kpiRequests';

export function fetchLookups() {
	return async function (dispatch) {
		dispatch({ type: LOOKUPS_FETCH_REQUEST });
		try {
			const res = await apiFetchLookups();
			dispatch({ type: LOOKUPS_FETCH_SUCCESS, payload: res.data });
		} catch (err) {
			const msg = (err.response && err.response.data && err.response.data.error) || err.message;
			dispatch({ type: LOOKUPS_FETCH_FAILURE, payload: msg });
		}
	};
}
